module.exports = __webpack_public_path__ + "img/68.1056b215.png";